module.exports = __webpack_public_path__ + "img/newStep2.bb1c199e.png";